import { Dispatch, SetStateAction } from 'react'

import dayjs from 'dayjs'

import { Challenge, ChallengeVisibility, FormFields } from '../../../types'

const DEFAULT_PHS: Challenge = {
  title: 'Retrato sutil',
  description:
    'Crea una foto de retrato con iluminación sutil, como de bajo una lámpara.',
  category: 'Fotografía',
  hashtags: ['retrato', 'luz'],
  instructions: 'Sube una foto al feed y usa los hashtags.',
  startDate: dayjs().format('DD/MM/YYYY'),
  endDate: dayjs().add(1, 'month').format('DD/MM/YYYY'),
  // status: ChallengeStatus.ACTIVE,
  image: null,
  altText: 'Mi mejor perfil cantando',
  participants: [],
  points: 1,
  visibility: true,
}

export type ChallengeFieldsParams = {
  state: Challenge
  hashtagInput: string
  setHashtagInput: Dispatch<SetStateAction<string>>
}

export const challengeFields = ({
  state,
  hashtagInput,
  setHashtagInput,
}: ChallengeFieldsParams): FormFields[] => {
  return [
    {
      title: 'Información básica',
      className: 'header lg',
      rowRight: [
        {
          type: 'input',
          label: 'Titulo del desafío',
          placeholder: DEFAULT_PHS.title,
          id: 'title',
          value: state.title,
        },
        {
          type: 'date',
          label: 'Fecha de inicio',
          placeholder: DEFAULT_PHS.startDate,
          id: 'startDate',
          value: state.startDate,
        },
        {
          type: 'date',
          label: 'Fecha de finalización',
          placeholder: DEFAULT_PHS.endDate,
          id: 'endDate',
          value: state.endDate,
        },
        {
          type: 'select',
          label: 'Categoria',
          placeholder: DEFAULT_PHS.category,
          id: 'category',
          value: state.category,
          options: ['Fotografía', 'Reels', 'Carrousel', 'Historias'],
        },
        // {
        //   type: 'select',
        //   label: 'Estado',
        //   placeholder: DEFAULT_PHS.status,
        //   id: 'status',
        //   value: state.status,
        //   options: [
        //     ChallengeStatus.ACTIVE,
        //     ChallengeStatus.ENDED,
        //     ChallengeStatus.UPCOMING,
        //   ],
        // },
        {
          type: 'select',
          label: 'Visibilidad',
          placeholder: DEFAULT_PHS.visibility
            ? ChallengeVisibility.VISIBLE
            : ChallengeVisibility.HIDDEN,
          id: 'visibility',
          value: state.visibility
            ? ChallengeVisibility.VISIBLE
            : ChallengeVisibility.HIDDEN,
          options: [ChallengeVisibility.VISIBLE, ChallengeVisibility.HIDDEN],
        },
      ],
      rowLeft: [
        {
          type: 'number',
          label: 'Puntos Ah-plausos!',
          id: 'points',
          value: state.points,
        },
        {
          type: 'text',
          label: 'Descripción',
          placeholder: DEFAULT_PHS.description,
          id: 'description',
          value: state.description,
        },
      ],
    },
    {
      title: 'Hashtags y reglas',
      className: 'left md',
      rowRight: [
        {
          type: 'tags',
          label: 'Hashtags del desafío',
          id: 'hashtags',
          value: state.hashtags,
          inputData: {
            inputValue: hashtagInput,
            setInputValue: setHashtagInput,
          },
        },
        {
          type: 'text',
          label: 'Instrucciones',
          placeholder: DEFAULT_PHS.instructions,
          id: 'instructions',
          value: state.instructions,
        },
      ],
    },
    {
      title: 'Imagen de portada',
      className: 'right md',
      rowRight: [
        {
          type: 'file',
          label: 'Arrastra una imagen o haz clic para subir',
          // placeholder: DEFAULT_PHS.image,
          id: 'image',
          value: state.image,
        },
        {
          type: 'input',
          label: 'Texto alternativo',
          placeholder: DEFAULT_PHS.altText,
          id: 'altText',
          value: state.altText,
        },
      ],
    },
  ]
}
